module.exports = __webpack_public_path__ + "img/rubin-img-10-crop.547c720d.png";